import React from 'react';
import { QueryProvider } from './QueryProvider';

export const CustomersProviders = ({ children }: any) => {
    return (
        <QueryProvider>
            {children}
        </QueryProvider>
    );
}